import { FunctionComponent as F } from "react";
import Typography from '@mui/material/Typography';
import TextTooltip from "../UI/Tooltip/TextTooltip";


interface IProps
{
  row: { productsPerMonth?: number, bundleId?: number | null, repurchase?: number },
  colour: string,
}

const ProductsPerMonth: F<IProps> = props =>
{
  const dosing = props.row;

  const renderValue = (productsPerMonth?: number) =>
    <Typography variant='body2' textAlign='right' sx={{ color: props.colour }}>
      {productsPerMonth !== undefined ? productsPerMonth.toFixed(1) : undefined}
    </Typography>

  if(props.row.repurchase === undefined)
    return renderValue(dosing.productsPerMonth)

  const tooltipText = "Repurchase " +
    (dosing.bundleId ? "bundle " : "") +
    "every " + Number(dosing.repurchase).toFixed(0) + " days";

  return (
    <TextTooltip lines={[tooltipText]}>
      {renderValue(dosing.productsPerMonth)}
    </TextTooltip>);
};




export default ProductsPerMonth;
